import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Template from './interfaz/Template';
import * as etiquetas from '../ApplicationResources.js';
import AuthenticatedComponent from './AuthenticatedComponent.js'
import axios from 'axios';
import { Button, Form, Select, Input, Modal, Row, Col } from 'antd';
import { connect } from 'react-redux';
import '../css/options_menu.css';
//import InputText from './interfaz/InputText';
const { Option } = Select;

class formAcusesPDF extends React.Component {
	constructor(props) {
		super(props);
		
		this.state = {
			listaDetalles: null,
			idProcesoElectoral: undefined,
			idDetalleProceso : 'Selecciona una opción',
			idEstado : undefined,
			idDistrito : undefined,
			claveElector : undefined,
			listaEstados : null,
			listaDistritos : null,
			btnGeneraDisabled : true,
			mjs: "",
			modalAbrir: false
		};

		this.handleEstadoChange = this.handleEstadoChange.bind(this);
		this.handleDistritoChange = this.handleDistritoChange.bind(this);
		this.handleIdAspiranteChange = this.handleIdAspiranteChange.bind(this);
		
	}

	/**
	* Obtiene la lista de los estados para el filtro de OC
	**/
	obtenerListaDetalles = async () => {
		var postData = {
			"idEstado": undefined
		};
		const detalles = await axios.post(process.env.REACT_APP_API_URL +
			"/ws_reclutaseycae_central/ws/obtenerDetalles", postData
			, {
				headers: {
					'Accept': 'application/json'
					, 'Content-Type': 'application/json'
				}
			}
		);

		return JSON.parse(JSON.stringify(detalles.data));
	}

	obtenerProcesoElectoral(detalleId) {
		this.setState({ btnContinuarDeshabilitado: true });

		var postData = {
			idDetalleProceso: detalleId
		}

		axios.post(process.env.REACT_APP_API_URL +
			"/ws_reclutaseycae_central/ws/obtenerProcesoElectoral", postData,
			{
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': localStorage.getItem("jwt-token") 
				}
			}
		).then(response => {
			this.setState({
				idProcesoElectoral: response.data !== null ?
					response.data : 0
			});
		}).catch(error => {
			var msjError = "";
			console.error("Error al consultar el proceso electoral " +
				"obtenerProcesoElectoral()", error);
		});
	}

	componentWillMount() {
		this.obtenerListaDetalles()
			.then(listaDetalles => {
				this.setState(
					{
						listaDetalles: listaDetalles
					}
				);
			})
			.catch(error => {
				console.error("Error al obtener lista de detalles procesos " +
					"componentWillMount()", error);


			});
	}

	handleDetalleChange = (detalleId) => {
		this.setState({
			idDetalleProceso: detalleId,
			btnGeneraDisabled : true, 
			listaEstados: null,
			listaDistritos:null,
			idEstado:undefined,
			idDistrito:undefined
		});

		this.obtenerProcesoElectoral(detalleId);

		this.obtenerListaEstados(detalleId)
		.then(listaEstados => {
			this.setState(
				{
					listaEstados: listaEstados
				});
		})
		.catch(error => {
		  console.error("Error al obtener lista de estados "+
			  "componentWillMount()",error);
		  this.mostrarError(error);

		});
	}

	generarAcusesPlatica = () => {
        var postData = {
            "idProcesoElectoral" : this.state.idProcesoElectoral,
            "idDetalleProceso" : this.state.idDetalleProceso,
            "idEstado" : this.state.idEstado,
            "idDistrito" : this.state.idDistrito,
            "claveElector" : this.state.claveElector
          }

        // Obteniendo los datos del servidor
        axios.post(process.env.REACT_APP_API_URL +
            '/ws_reclutaseycae_central/ws/generaAcusesPlatica', postData,
            {
                  headers: {
                      'Accept': 'application/json'
                      ,'Content-Type': 'application/json'
					  , 'Authorization': localStorage.getItem("jwt-token") 
                  }
              }
          ).then(response => {
              // Si se generó todo bien
            if(response.data === true) {
				this.setState({mjs: 'Los archivos fueron generados con éxito' });
				this.setState({modalAbrir:true});
			} else {
				this.setState({mjs: 'Los archivos no se generaron' });
				this.setState({modalAbrir:true});
              }
          }).catch(error => {
			this.setState({mjs: 'Se generó un error al intentar crear los acuses.' });
			this.setState({modalAbrir:true});
          });
	}

	handleEstadoChange = (estadoId) => {
		this.setState({
			idEstado: estadoId,
			listaDistritos: null,
			idDistrito: undefined
		});

		this.obtenerListaDistritos(estadoId)
        .then(listaDistritos => {
            this.setState({
							listaDistritos:listaDistritos
                         });
        }).catch(error => {
            console.error('Ocurrió un error en handleEstadoChange()', error);
            this.mostrarError(error);
        });
	}

	handleDistritoChange = (distritoId) => {
		this.setState({
			idDistrito: distritoId,
			btnGeneraDisabled : false
		});
	}

	handleIdAspiranteChange = (aspiranteId) => {
		this.setState({
			claveElector: aspiranteId.target.value
		});
	}

	/**
	* Obtiene la lista de los estados para el filtro de OC
	**/
	obtenerListaEstados = async (idDetalleProceso) =>{
		var postData = {
			idDetalleProceso : idDetalleProceso,
			idEstado : 0
		};

		const estados = await axios.post(process.env.REACT_APP_API_URL +
			"/ws_reclutaseycae_central/ws/obtenerEstadosPorDetalle", postData
					, {
							headers: {
								'Accept': 'application/json'
								 ,'Content-Type': 'application/json'
								 , 'Authorization': localStorage.getItem("jwt-token") 
							}
					}
			);

			return JSON.parse(JSON.stringify(estados.data));
	}

	/**
	* Obtiene la lista de distritos para el filtro de OC y JL
	**/
	obtenerListaDistritos = async (idEstado) =>{
		var postData = {
			idProcesoElectoral : this.state.idProcesoElectoral,
			idDetalleProceso : this.state.idDetalleProceso,
			idEstado : idEstado,
			idDistrito : 0
		};

		const distritos = await axios.post(process.env.REACT_APP_API_URL +
			"/ws_reclutaseycae_central/ws/obtenerDistritos", postData
					, {
							headers: {
								'Accept': 'application/json'
								 ,'Content-Type': 'application/json'
								 , 'Authorization': localStorage.getItem("jwt-token") 
							}
					}
			);
			return JSON.parse(JSON.stringify(distritos.data));
	}

    onClickModal = () =>{
        this.setState({modalAbrir: false});
    }

	render() {
		return (
			<AuthenticatedComponent externo={false}>
				<Template contenido={
					<>
						<div className='pantalla_acuses_platicas'>

							<Form id="formAcusesPDF" >
								<Row gutter={16}>
									<Col sm={24} md={24} lg={24}>
										<h3 className='encabezado_proceso'>Acuses de Cápsula de Inducción:</h3>
									</Col>
								</Row>

								<Row gutter={16}>
									<Col sm={24} md={24} lg={24}>
										<Select className="select_form"
										placeholder="Selecciona una opción" id="lista-procesos"
										value={this.state.idDetalleProceso}
										onChange={this.handleDetalleChange}
										>
											{
												this.state.listaDetalles &&
												this.state.listaDetalles.map((detalle, index) => (
													<Option key={index} value={detalle.id}>
														{detalle.valor}
													</Option>
												))
											}
										</Select>
									</Col>
								</Row>

								<Row gutter={16}>
									<Col sm={24} md={24} lg={24}>
										<Select className="select_form"
											placeholder="Selecciona JLE" id="lista-estados"
											value={this.state.idEstado}
											onChange={this.handleEstadoChange}>
											{
												this.state.listaEstados &&
												this.state.listaEstados.map((estado, index) => (
													<Option key={index} value={estado.idEstado}>
														{estado.nombreEstado}
													</Option>
												))
											}
										</Select>	
									</Col>
								</Row>

								<Row gutter={16}>
									<Col sm={24} md={24} lg={24}>
										<Select className="select_form" id="lista-distritos"
											placeholder="Selecciona JDE "
											onChange={this.handleDistritoChange}
											value={this.state.idDistrito}>
											{
												this.state.listaDistritos &&
												this.state.listaDistritos.map((estado, index) => (
													<Option key={index} value={estado.idDistrito}>
													{estado.idDistrito + '-' +  estado.nombreDistrito}
													</Option>
												))
											}
										</Select>
									</Col>
								</Row>

								<Row gutter={16}>
									<Col sm={24} md={24} lg={24}>
										<Input className="select_form" value={this.state.claveElector}
											onChange={this.handleIdAspiranteChange}
											placeholder="Clave elector o FUAR"
										/>
									</Col>
								</Row>

								<Row gutter={16}>
									<Col sm={24} md={24} lg={24}>
										<Button onClick={this.generarAcusesPlatica} disabled={this.state.btnGeneraDisabled}>
										Generar acuses
										</Button>
									</Col>
								</Row>

							</Form>

						</div>

					</>
				}
					guia={false} />

				<Modal title={null}
                       centered
                       visible={this.state.modalAbrir}
                       onOk={null}
                       onCancel={null}
                       closable={false}
                       footer={null}>
                    <div style={{'fontSize': '16px'}}>
                        {this.state.mjs}
                    </div>
                    <br/><br/>
                    <div id="modal_botones">
                        <Button className="botonesModal" style={{width: 150}} onClick={this.onClickModal}> Aceptar </Button>
                    </div>
                </Modal>
			</AuthenticatedComponent>
		);
	}
};

const mapStateToProps = state => {

    const datosUsuario = (state.user && state.user.currentUser) ? state.user.currentUser: undefined;

    return {
        datosUsuario: datosUsuario,
    };
}

export default withRouter(connect(mapStateToProps)(formAcusesPDF));
